import { render } from "./SuperviseurDashboardPage.vue?vue&type=template&id=6a2dd2e1&ts=true"
import script from "./SuperviseurDashboardPage.vue?vue&type=script&lang=ts"
export * from "./SuperviseurDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__